export default "__VITE_ASSET__Bc5b6RcE__"